import ChecklistManagementQuoteBuilder from "@/components/ChecklistManagementQuoteBuilder";

interface SimpleProjectDashboardProps {
  projectId?: string;
  quoteId?: string | null;
  onBack?: () => void;
}

export function SimpleProjectDashboard({
  projectId,
  quoteId,
  onBack,
}: SimpleProjectDashboardProps) {
  return (
    <ChecklistManagementQuoteBuilder projectId={projectId} quoteId={quoteId} onBack={onBack} />
  );
}

export default SimpleProjectDashboard;
